/* eslint-disable react/no-array-index-key */
/**
*
* ImportSheet
*
*/

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import readBlob from 'utils/readBlob.js';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import ReactSelect from '../ReactSelect/index.jsx';
import messages from './messages.js';
import InputFile from '../InputFile/index.jsx';

const InlineGroup = styled.div`
  margin: 20px 0;
  @media (min-width: ${(p) => p.theme.screenXsMin}) {
    display: flex;
    align-items: center;
  }
  label {
    display: block;
    width: 6em;
    margin-right: 1rem;
  }
  #select-sheet {
    width: 15em;
  }
  #source {
    flex-grow: 1;
  }
`;

function parseRows(data) {
  const [fields, ...rows] = data;
  return {
    fields,
    rows: rows.map((row) => {
      const obj = {};
      fields.forEach((h, i) => {
        obj[h] = row[i];
      });
      return obj;
    }),
  };
}

function ImportSheet(props) {
  const { onChange } = props;
  const file = useRef(null);
  const [sheets, setSheets] = useState();
  const [sheetName, setSheetName] = useState();

  async function handleSheet(sheet) {
    const { blob, filename } = file.current;
    const rows = await readXlsxFile(blob, { sheet });
    const sheetData = parseRows(rows);
    onChange({ filename, sheetName, sheetData });
  }

  async function handleFile(files) {
    if (!files.length) {
      return;
    }
    const blob = await readBlob(files[0], 'arrayBuffer');
    const filename = files[0].name;
    file.current = { blob, filename };
    const fileSheets = await readSheetNames(blob);
    setSheets(fileSheets);
    changeSheet(fileSheets[0]);
  }

  function changeSheet(name) {
    setSheetName(name);
    handleSheet(name);
  }

  return (
    <>
      <div className="d-flex align-items-baseline">
        <InputFile accept=".xls,.xlsx,.ods" id="input-sheet" onChange={handleFile} className="btn btn-primary">
          <FormattedMessage {...messages.selectFile} />
        </InputFile>
        <span className="small ms-2">{file.filename}</span>
      </div>
      {sheets && sheets.length > 1 && (
        <InlineGroup>
          <label htmlFor="select-sheet"><FormattedMessage {...messages.selectSheet} /></label>
          <ReactSelect
            id="select-sheet"
            value={sheetName}
            options={sheets.map((o) => ({ label: o, value: o }))}
            onChange={changeSheet}
            large
          />
        </InlineGroup>
      )}
    </>
  );
}

ImportSheet.propTypes = {
  onChange: PropTypes.func,
};

export default ImportSheet;
